<template>
  <div id="app-donation">
    <donation-head></donation-head>
    <nav-bar></nav-bar>
    <donation-info></donation-info>
    <donation-foot></donation-foot>
  </div>
</template>
<script>
import animate from 'animate.css'
import donationHead from "../Public/head";
import navBar from "../Public/nav";
import donationInfo from "./donation_info";
import donationFoot from "../Public/foot";    

export default {
  components:{
    donationHead,
    navBar,
    donationFoot,
    donationInfo
  }
}
</script>
<style lang="scss" scoped>
#app-donation{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Donation/donation_index.vue